import useAuth from './useAuth';

export default function useDistributionMarket() {
  const { distribution } = useAuth();

  const countryCode = distribution?.address.country_code;

  switch (countryCode) {
    case 'BE':
      return 'BE';
    case 'NL':
    case 'AW':
    case 'BQ':
    case 'CW':
    default:
      return 'NL';
  }
}
